import { state as defaultState, GameStepsState } from '@/store/modules/gamesteps/state';
import { RootState } from '@/store/state';
import { Module } from 'vuex';
import { getters } from '@/store/modules/gamesteps/getters';
import { mutations } from '@/store/modules/gamesteps/mutations';
import { actions } from '@/store/modules/gamesteps/actions';

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
  getters,
  actions
} as Module<GameStepsState, RootState>;
